"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownControl_1 = tslib_1.__importDefault(require("../DropdownControl"));
var dropdowns_1 = require("../../../constants/dropdowns");
var translations_1 = require("../../../utils/translations");
var LegendPositionControl = /** @class */ (function (_super) {
    tslib_1.__extends(LegendPositionControl, _super);
    function LegendPositionControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendPositionControl.prototype.render = function () {
        return (react_1.default.createElement(DropdownControl_1.default, { value: this.props.value, valuePath: "legend.position", labelText: "properties.legend.position", disabled: this.props.disabled, properties: this.props.properties, pushData: this.props.pushData, items: this.generateDropdownItems(), showDisabledMessage: this.props.showDisabledMessage }));
    };
    LegendPositionControl.prototype.generateDropdownItems = function () {
        return translations_1.getTranslatedDropdownItems(dropdowns_1.legendPositionDropdownItems, this.props.intl);
    };
    return LegendPositionControl;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(LegendPositionControl);
//# sourceMappingURL=LegendPositionControl.js.map